import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Space, Input, TextArea } from "@masterteam/mt-design-react";

import Upload from "../../../Upload";
import Attachments from "../../../AttachmentsList";

import { useIsAr } from "../../../../Hooks";
import { formatDate } from "../../../../helpers";

import "./style.scss";

function Info({
  data = {},
  type,
  notes,
  setNotes,
  attachments,
  setAttachments
}) {
  const [isAr] = useIsAr();
  const [supportedExtensions] = useSelector(({ theme }) => {
    return [theme.DocumentType?.item?.Items?.map((item) => item.Value)];
  });

  const isReject = type === "reject";

  const intl = useIntl();

  const unitOfMeasure =
    data?.Form?.UnitOfMeasure === "Percentage"
      ? "%"
      : isAr
      ? data?.Form?.ArabicUnitDetails
      : data?.Form?.EnglishUnitDetails;

  return (
    <Space className="approve-reject-modal__info" direction="vertical">
      <Space className="approve-reject-modal__info__fields" size="large">
        <Space
          className="approve-reject-modal__info__fields__field"
          direction="vertical"
        >
          <label>
            <FormattedMessage id="kpi-details.target-value" />
          </label>
          <Input
            disabled
            value={`${data?.Form?.Target || 0} ${unitOfMeasure}`}
          />
        </Space>
        <Space
          className="approve-reject-modal__info__fields__field"
          direction="vertical"
        >
          <label>
            <FormattedMessage id="kpi-details.value" />
          </label>
          <Input
            disabled
            value={`${data?.Form?.Value || 0} ${unitOfMeasure}`}
          />
        </Space>
        <Space
          className="approve-reject-modal__info__fields__field"
          direction="vertical"
        >
          <label>
            <FormattedMessage id="kpi-details.date" />
          </label>
          <Input
            disabled
            value={data?.Form?.DueDate ? formatDate(data?.Form?.DueDate) : ""}
          />
        </Space>
      </Space>
      <Space
        className="approve-reject-modal__info__textareas"
        direction="vertical"
      >
        <Space
          className="approve-reject-modal__info__textareas__textarea"
          direction="vertical"
        >
          <label>
            <FormattedMessage id="kpi-details.justifcations" />
          </label>
          <Space className="approve-reject-modal__info__textareas__textarea__text">
            {data?.Form?.Justification}
          </Space>
        </Space>
        <Space
          className="approve-reject-modal__info__textareas__textarea"
          direction="vertical"
        >
          <label>
            <FormattedMessage id="kpi-details.corrective-action" />
          </label>
          <Space className="approve-reject-modal__info__textareas__textarea__text">
            {data?.Form?.CorrectiveAction}
          </Space>
        </Space>
        <Space
          className="approve-reject-modal__info__textareas__textarea"
          direction="vertical"
        >
          <label>
            <FormattedMessage id="kpi-details.more-information" />
          </label>
          <Space className="approve-reject-modal__info__textareas__textarea__text">
            {data?.Form?.MoreInformation}
          </Space>
        </Space>

        <Space
          className="approve-reject-modal__info__textareas__textarea"
          direction="vertical"
          style={{ paddingBottom: "32px" }}
        >
          <label>
            <FormattedMessage id="common.attachments" />
          </label>
          <Space className="approve-reject-modal__info__textareas__textarea__text">
            <Attachments files={data?.Attachments} />
          </Space>
        </Space>
      </Space>

      <Space direction="vertical">
        <Space direction="vertical" marginHeight={16}>
          <label>
            <FormattedMessage id="common.notes" />
          </label>
          <TextArea
            value={notes}
            onChange={(e) => setNotes(e.currentTarget.value)}
            placeholder={intl.formatMessage({ id: "common.notes" })}
            error={isReject ? !notes?.trim()?.length : false}
          />
        </Space>
        <Space>
          <Upload
            name="Attachments"
            label={<FormattedMessage id="common.attachment" />}
            onChange={setAttachments}
            multiple
            onDelete={setAttachments}
            attachments={attachments}
            accept={{
              "image/*": supportedExtensions.map((item) => `.${item}`),
              "audio/*": supportedExtensions.map((item) => `.${item}`),
              "video/*": supportedExtensions.map((item) => `.${item}`),
              "text/*": supportedExtensions.map((item) => `.${item}`),
              "font/*": supportedExtensions.map((item) => `.${item}`),
              "application/*": supportedExtensions.map((item) => `.${item}`)
            }}
          />
        </Space>
      </Space>
    </Space>
  );
}

export default Info;
